import React, { Component } from 'react';
import { Grid, Cell, Card, CardTitle, CardText, CardActions, Button } from 'react-mdl';
import FontAwesome from 'react-fa';

export default class AdultSundaySchool extends Component {
  render() {

    return (
      <div>
        <div style={{width: '90%', margin: 'auto'}}>

          <Grid>
            <Cell col={12}>
              <Card shadow={0} style={{width: '100%', margin: 'auto'}}>
                <CardTitle style={{ color: '#fff', height: '150px',  background: 'url(/images/lighthouse.jpg) center / cover'}}>成人主日學 Adult Sunday School (粵語/国语)</CardTitle>
                <CardText>
                  <p>
                    &emsp;<FontAwesome name='calendar'/> : &emsp;逢第二、三、四主日，晚上八時至九時 <br/>
                    &emsp;<FontAwesome name='map-marker'/> : &emsp;Zoom  或疫後 Portswood Church <br/>
                    &emsp;<FontAwesome name='address-card'/> : &emsp;衞傳道 Pastor Henry <br/>
                    &emsp;<FontAwesome name='envelope'/> : &emsp;henry.wai@sccc.org.uk <br/>
                  </p>
                  <h6>
                  教會將於2026年二月份開始新一季的成人主日學課程，詳細的內容如下:<br/>
                  <br/></h6>

<h5>                  
&emsp;1) 課程：廣東話：門徒訓練 <br/></h5>
<h6>
&emsp;&emsp;時間：2026年2,3,4,5,6 月第二，四週星期四、五晚上或星期六中午(未確定)，晚上八時至十時，共十課。<br/>
&emsp;&emsp;課程要求：實體課程，教會中心上課，出席率需要達80%以上，承諾要完成課程，每班六至八人，最多两班。<br/>
&emsp;&emsp;註冊要求： 需向衞傳道面試<br/>
&emsp;&emsp;課程簡介：<br/>
&emsp;&emsp;&emsp;敬拜/禱告操練, 靈修分享, 帶領查經技巧訓練和實, 帶領慕道朋友信主/成長。<br/>
  <br/></h6>
   
<h5>
&emsp;2) 課程：廣東話：雅各書(中神課程) <br/></h5>
<h6>
&emsp;&emsp;講師：余振陵博士<br/>
&emsp;&emsp;時間：2026年2,3,4月，第二，三，四 主日，晚上八時至九時，共八課。<br/>
&emsp;&emsp;地點：Zoom線上形式教學<br/>
&emsp;&emsp;課程簡介：<br/>
&emsp;&emsp;&emsp;《雅各書》鼓勵早期教會信徒，雖然面對內外各種試煉，不要被世俗同化，不要跟隨世俗的價值和行事方式，卻要專一尋求滿有恩慈的上帝。更鼓勵信徒群體要彼此認罪、互相代求，在艱難試煉中成為彼此的支持，以至信徒群體最終能得以完全。<br/>
&emsp;&emsp;課程內容：<br/>
&emsp;&emsp;&emsp;導論<br/>
&emsp;&emsp;&emsp;使徒要成全完備<br/>
&emsp;&emsp;&emsp;要有完全的信心：實行王者的律法<br/>
&emsp;&emsp;&emsp;要有從上頭來的智慧<br/>
&emsp;&emsp;&emsp;上帝末世審判的來臨<br/>
&emsp;&emsp;&emsp;成全完備的群體<br/>
<br/></h6>
                </CardText>
                <CardActions border>
                  <div>
      <h6>Scan QR Code to register</h6>
      <img src="https://res.sccc.org.uk/docs/adultSundaySchool-qr.jpg" alt="QR Code" style={{ width: '200px' }} />
    </div>
                  <Button colored><a href="https://forms.gle/MkuoK3ZmnjCEYETA7">Online Registration Form</a></Button>
                </CardActions>
              </Card>
            </Cell>
          </Grid>
        </div>
      </div>
    );
  }
}
